/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { SidebarIdPlanSettings } from '@jira/navigation-apps__constants/src/SidebarIdPlanSettings.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import {
	planLayout,
	planLayoutWithoutInvalidation,
} from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanSettingsScenariosRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanSettingsScenariosRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import PlanSettingsScenariosPage, {
	LazyPlanSettingsScenarios,
} from './ui/plan-settings-scenarios/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getConditionalSidebarResources = () => {
	return fg('plan_settings_sidebar_migrate_to_relay') ? [] : getNavigationSidebarPlanResources();
};

export const softwarePlanSettingsScenariosRouteEntry: Route = createEntry(
	softwarePlanSettingsScenariosRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: PlanSettingsScenariosPage,
		layout: fg('plan_settings_sidebar_migrate_to_relay')
			? composeLayouts(globalLayout, planLayoutWithoutInvalidation)
			: composeLayouts(globalLayout, planLayout),

		resources: [
			...getNavigationResources(),
			...getConditionalSidebarResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
			...getPlansBacklogResource(),
			advancedRoadmapsReduxStoreStateResource,
		],

		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},

		navigation: {
			sidebarId: SidebarIdPlanSettings,
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanSettingsScenarios],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
